<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-select
          :label="$t('labels.search_field')"
          :items="items"
          item-text="text"
          item-value="value"
          outlined
          v-model="fitlerName"
          :disabled="items.length <= 1"
        ></v-select>
      </v-col>
      <v-col cols="6">
        <v-text-field
          :append-icon="
            queries.query[fitlerName] && queries.query[fitlerName] !== ''
              ? `mdi-close`
              : ''
          "
          @click:append="removeSpecificFilter(fitlerName)"
          outlined
          :label="$t(`labels.search`)"
          v-model="queries.query[fitlerName]"
          @keypress.enter="handleFilter(fitlerName)"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn @click="handleFilter(fitlerName)" class="primary" large>{{
          $t("button.search")
        }}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "GlobalSearchFilter",
  props: {
    queries: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fitlerName: ""
    };
  },
  methods: {
    removeSpecificFilter(queryKey) {
      this.queries.query[queryKey] = "";
      if (this.$route.query[queryKey]) {
        const query = {
          ...this.$route.query
        };
        delete query[queryKey];

        this.$router.push({ query });
      }
    },
    handleFilter(queryKey) {
      const query = {};
      let routeQuery = { ...this.$route.query };
      query[queryKey] = this.queries.query[queryKey];
      if (query[queryKey] === "") {
        delete query[queryKey];
        this.queries.query[queryKey] = "";
      }
      if (routeQuery.page > 1) {
        routeQuery.page = 1;
      }
      if (this.queries.query[queryKey] !== "") {
        this.$router.push({ query: { ...routeQuery, ...query } });
      }
    },

    ClearFilter() {
      const newQueryies = { ...this.$route.query };
      // this.fitlerName = "";
      Object.keys(newQueryies).forEach(item => {
        if (this.queryKeys.includes(item)) {
          delete newQueryies[item];
          this.queries.query[item] = "";
        }
      });
      this.$router.push({ query: newQueryies });
    }
  },
  computed: {
    queryKeys() {
      return Object.keys(this.queries.query);
    },
    items() {
      const items = [];
      const queries = this.queries.query;
      for (let key in queries) {
        items.push({ text: this.$t(`labels.${key}`), value: key });
      }
      return items;
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        let queries = { ...query };

        const formQueries = Object.keys(this.queries.query);
        Object.keys(queries).forEach(keyQuery => {
          if (formQueries.includes(keyQuery)) {
            this.fitlerName = keyQuery;
            this.queries.query[keyQuery] = query[keyQuery];
          }
        });
      },
      immediate: true
    },
    items: {
      handler(value) {
        this.fitlerName = value[0].value;
      },
      immediate: true
    }
  }
};
</script>
